import ElakayImage from "../../../components/images/ElakayImage";
import { elakayAutoText } from "../../pageInside/dataElakay";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { toImageUrl } from "../../../config";
import Price from "../../pageInside/productsPrice";
import CateryName from "../../pageInside/cateryName";
import elakayEmptyBox from "../../Layout/icon/elakayEmptyBox.png";
import { IoHeartDislikeSharp } from "react-icons/io5";
import { isAuthenticated, addFollowUserShop } from "../../auth";
import "./followPageMatrice.css";
import { getProductPrimaryImage } from "../../auth/elakay-utils";
import { formatLakayShopTitle } from "../../../utils/lakayShopName";
import { formatFollowersCount } from "../../../utils/formatFollowersCount";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["followPageMatrice"]?.[key] || fallback;

const getImageUrl = (item) => getProductPrimaryImage(item) || null;

const COLORS2 = [
  "GhostWhite", "Ivory", "MintCream", "Silver", "White",
  "LightGray", "Gainsboro", "LightSlateGray", "LightSteelBlue",
  "AliceBlue", "AntiqueWhite", "Azure", "Beige", "Bisque",
  "BlanchedAlmond", "Cornsilk", "Cyan", "Chartreuse", "BurlyWood",
  "Coral", "LightBlue", "LightPink", "LightYellow", "MistyRose",
  "PeachPuff", "PowderBlue", "LemonChiffon", "Lavender",
  "HoneyDew", "FloralWhite",
];

const getRandomColor = () => COLORS2[Math.floor(Math.random() * COLORS2.length)];

const ProductShowcase = (props) => {

 const {
  infoSource,
  products = {},              // products.products = matrice triée
  title = "",
  headerBackgroundImage = "",
  facet=["followShopUser"],
  loadProductsByArrival,
  arrayFacet= ['userViewMatrix', "historySearchMatrix", "followShopUser"],
       // 🎨 TITRE SECONDAIRE (card-title)
        showSlideTitle          = false,
        slideTitleFontFamily    = 'inherit',
        slideTitleFontSize      = '1rem',
        slideTitleFontWeight    = 600,
        slideTitleFontStyle     = 'normal',
        slideTitleLetterSpacing = 'normal',
        slideTitleLineHeight    = 1.2,
        slideTitleTextTransform = 'none',
        slideTitleTextAlign     = 'left',
        slideTitleColor         = '#1f2937',
        slideTitleTextShadow    = 'none',
        slideTitleAnimation     = null,

        // 🔗 LIEN SECONDAIRE (card-subtitle)
        showSlideLink               = false,
        slideLinkText               = 'seeMore',
        slideLinkFontFamily         = 'inherit',
        slideLinkFontSize           = '0.875rem',
        slideLinkFontWeight         = 500,
        slideLinkFontStyle          = 'normal',
        slideLinkLetterSpacing      = 'normal',
        slideLinkTextTransform      = 'none',
        slideLinkTextDecoration     = 'none',
        slideLinkColor              = '#007399',
        slideLinkHoverColor         = '#005577',
        slideLinkBackgroundColor    = 'transparent',
        slideLinkPadding            = '0',
        slideLinkBorderRadius       = '0',
        slideLinkTextShadow         = 'none',
        slideLinkClass              = '',
  maxProducts = 4,  
  content_BackGroundColor=  "0, 0%, 80%"       // Max logique demandé (1..7)

  
} =props
__setElakayInfoSource(infoSource);


  const list = Array.isArray(products?.products) ? products.products : [];

  // ✅ On limite la liste d'entrée à maxProducts
  const limitedProducts = useMemo(() => list.slice(0, Math.max(0, maxProducts)), [list, maxProducts]);

  // ✅ Si on a exactement 7 produits (maxProducts=7), le dernier peut être "background"
  const hasBackground = maxProducts >= 7 && limitedProducts.length === 7;
  const backgroundProduct = hasBackground ? limitedProducts[6] : null;

  // ✅ Produits affichés en grille (foreground)
  const displayProducts = hasBackground ? limitedProducts.slice(0, 6) : limitedProducts;

  // ✅ Nombre de cases à afficher dans la grille (comme ton "totalCells" du model)
  // Ici: si maxProducts=7 => grille de 6 (car 7e réservé au background)
  // Sinon: grille = maxProducts (ex: maxProducts=4 => 4 cases)
  const totalCells = useMemo(() => {
    const safeMax = Math.max(0, Math.min(7, maxProducts));
    return safeMax >= 7 ? 6 : safeMax;
  }, [maxProducts]);


      // Style inline card-title
    const slideTitleStyle = {
        fontFamily    : slideTitleFontFamily,
        fontSize      : slideTitleFontSize,
        fontWeight    : slideTitleFontWeight,
        fontStyle     : slideTitleFontStyle,
        letterSpacing : slideTitleLetterSpacing,
        lineHeight    : slideTitleLineHeight,
        textTransform : slideTitleTextTransform,
        textAlign     : slideTitleTextAlign,
        color         : slideTitleColor,
        textShadow    : slideTitleTextShadow,
    };

    // Classe animation du titre slide
    const slideTitleClass = slideTitleAnimation
        ? `card-title ${slideTitleAnimation}`
        : 'card-title';

    // Style inline card-subtitle (lien)
    const slideLinkStyle = {
        fontFamily     : slideLinkFontFamily,
        fontSize       : slideLinkFontSize,
        fontWeight     : slideLinkFontWeight,
        fontStyle      : slideLinkFontStyle,
        letterSpacing  : slideLinkLetterSpacing,
        textTransform  : slideLinkTextTransform,
        textDecoration : slideLinkTextDecoration,
        color          : slideLinkColor,
        backgroundColor: slideLinkBackgroundColor,
        padding        : slideLinkPadding,
        borderRadius   : slideLinkBorderRadius,
        textShadow     : slideLinkTextShadow,
        '--link-hover-color': slideLinkHoverColor,
    };

    // Texte résolu du lien
    const resolvedSlideLinkText =
        infoSource?.laguangeElakay?.("Link", infoSource?.languageAPI)?.[slideLinkText]
        || "See More";


  const getDefaultDivImage = (key) => (
    <div key={key} className="product-square-card empty" data-rank="0">
      <div
        className="square-card-inner fallback-image-wrapper"
        style={{ backgroundColor: getRandomColor() }}
      >
        <img
          className="fallback-image"
          src={elakayEmptyBox}
          alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).lakayFollowPageMatrice.t001}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
    </div>
  );

   const {pageTopRef, divFollowSliderMatrix, scrollToParagraph} = infoSource;
   const { token } = isAuthenticated();
const clickToFollowShop = () => {
   scrollToParagraph(pageTopRef);
  scrollToParagraph(divFollowSliderMatrix);
    addFollowUserShop(token, products?.owner, products?.shopId, false).then(data => {
        if (data.error) {
        } else {
            loadProductsByArrival({}, ["followMe", "followShopUser"])
        }
    });
};

  // ✅ Même logique que ton model: on remplit les images vides jusqu'à totalCells
  const paddedProducts = useMemo(() => {
    const base = Array.isArray(displayProducts) ? displayProducts.slice(0, totalCells) : [];
    const missingCount = totalCells - base.length;

    const placeholders = Array.from({ length: Math.max(0, missingCount) }, (_, j) => ({
      __empty: true,
      __key: `missing-${j}`,
    }));

    return [...base, ...placeholders];
  }, [displayProducts, totalCells]);

  // Si aucun produit et totalCells=0 => rien
  if (totalCells === 0) return null;

  return (
    <div className="image-matrix-card">
      {/* Background discret (si 7 produits) */}
      {headerBackgroundImage && (
        <div
          className="card-background"
        >
          <ElakayImage src={headerBackgroundImage} preset="product-card" alt="" aria-hidden="true" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
          <div className="card-background-overlay"></div>
        </div>
      )}

      <div
       className="card-content_"
         style={{
        "--bg-color-1": `hsla(${content_BackGroundColor}, 0.85)`,
        "--bg-color-2": `hsla(${content_BackGroundColor}, 0.78)`,
        "--bg-color-3": `hsla(${content_BackGroundColor}, 0.76)`,
        "--bg-color-4": `hsla(${content_BackGroundColor}, 0.75)`,
        "--bg-color-5": `hsla(${content_BackGroundColor}, 0.73)`,
        "--bg-color-6": `hsla(${content_BackGroundColor}, 0.60)`
      }}
       >
        {/* ZONE HAUTE - INFORMATIONS */}
        <div className="card-info-zone">
          {/* {headerBackgroundImage && (
            <div
              className="info-zone-background"
              style={{ backgroundImage: `url(${headerBackgroundImage})` }}
            >
              <div className="info-zone-overlay"></div>
            </div>
          )} */}

          <div className="info-zone-content">

            {['userViewMatrix', "historySearchMatrix"].includes(facet) &&<>
             {title && (<h2 className="card-title" style={showSlideTitle ? slideTitleStyle: {}}>
               <CateryName items={products} {...props} />
               </h2>)}
                 <Link
                 className="card-subtitle"
                    // Public, non-guessable category id (same convention as
                    // CategoryProductsLoop's getPublicIdentifier()) — falls
                    // back to the raw id only if a group predates the
                    // categoryPublicId field being added to the pipeline.
                    to={`/product/${products?.categoryPublicId || products?.categoryID}`}
                    style={showSlideLink ? slideLinkStyle: {}}
                        >
                               {/* {infoSource.language(infoSource, "Link", "seeMore")} */}
                               {/* <span className="see-more-arrow">→</span> */}
                               {resolvedSlideLinkText}
                      </Link>
                      </>
                    }
          


    {["followShopUser"].includes(facet) && (() => {
      const shopTitle = formatLakayShopTitle((Array.isArray(products?.shopName) ? products.shopName[0] : products?.shopName), __elakayText("t001", "Lakay"));
      return (
  <>
    {/* {title && ( <h2 className="card-title"  style={showSlideTitle ? slideTitleStyle: {}}> Lakay {(Array.isArray(products?.shopName) ? products.shopName[0] : products?.shopName) || ""} </h2>)} */}
{title && (
  <h2 
    className="card-title" 
    style={showSlideTitle ? slideTitleStyle : {}}
  >
    <span>{shopTitle}</span>
    {/* One vertical control: the heart (action) and, under it, the compact
        follower count (information only, not clickable). */}
    <span className="follow-shop-control">
      <button
        type="button"
        className="follow-shop-heart is-following"
        onClick={clickToFollowShop}
        aria-label={elakayAutoText("h_msl_unfollow_named", "Unfollow {name}", { name: shopTitle })}
        title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).lakayFollowPageMatrice.t002}
      >
        <IoHeartDislikeSharp aria-hidden="true" />
      </button>
      {products?.followers !== undefined && (
        <span className="follow-shop-count" title={elakayAutoText("h_msl_followers", "{count} followers", { count: products.followers })}>
          {formatFollowersCount(products.followers)}
        </span>
      )}
    </span>
  </h2>
)}
    <Link
      className="card-subtitle"
      to={products?.publicPath || `/lakay-ShopSeller/${products?.owner}${products?.shopId ? `?shop=${products.shopId}` : ""}`}
      style={showSlideLink ? slideLinkStyle: {}}    
    >
      {/* {infoSource.language(infoSource, "Link", "seeMore")} */}
      {resolvedSlideLinkText}
    </Link>
  </>
      );
    })()}

          </div>

        </div>

        {/* ZONE BASSE - IMAGES PRODUITS */}
        <div className="card-images-zone">
          {/* ✅ La classe matrix-X doit rester cohérente avec le nombre de CASES affichées */}
          <div className={`products-matrix matrix-${totalCells}`}>
            {paddedProducts.map((product, index) => {
              // Placeholder
              if (product?.__empty) return getDefaultDivImage(product.__key);

              return (
                <div
                  key={product?._id || product?.id || `p-${index}`}
                  className="product-square-card"
                  data-rank={index + 1}
                >
                  <div className="square-card-inner">
                    <ElakayImage preset="product-card" fallback={elakayEmptyBox}
                      src={toImageUrl(getImageUrl(product))}
                      alt={product?.name || `Product ${index + 1}`}
                      className="square-card-image"
                      onError={(e) => {
                        // fallback simple
                        e.currentTarget.src = elakayEmptyBox;
                        e.currentTarget.onerror = null;
                      }}
                    />

                    {/* {product?.price !== undefined && (
                      <div className="price-overlay">
                        <span className="price-current">
                          <Price products={product} showAddToCartButton={false} />
                        </span>
                      </div>
                    )} */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

// Shared with the Provider "Recently Viewed Providers" card (same placeholder palette).
export { COLORS2 as FOLLOW_PLACEHOLDER_COLORS };

export default ProductShowcase;
